<template>
    <svg
        id="Agrupar_6"
        :class="{ selected: !!selectedRegionName }"
        class="brasilidade-map"
        data-name="Agrupar 6"
        viewBox="0 0 1920 1826"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g class="brasilidade-br">
            <component
                :is="componentsMap[c]"
                v-for="c in Object.keys(componentsMap)"
                :key="c"
                :class="{ selected: selectedRegionName === c }"
                class="brasilidade-region"
                @click.native="$emit('click', c)"
            />
        </g>
        <text
            id="sua_camiseta_é_criada_aqui_"
            class="cls-12"
            data-name="sua camiseta é criada aqui!"
            transform="translate(1595.69 1560.691) scale(1.12 1.119)"
        >
            <tspan x="0">sua camiseta</tspan>
            <tspan dy="44.832" x="0">é criada aqui!</tspan>
        </text>
        <path
            id="Forma_87"
            class="cls-3"
            d="M1353.96 1250.72c14.26.56 12.36 18.61 1 19.05c-10.59.41-14.96-15.93-1-19.05zm-2 22.34c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 21c0-0 5-0 5-0c0 0 0 13 0 13c0 0-5 0-5 0c0 0 0-13 0-13zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 22c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 24c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c0 0-5 0-5 0c0 0 0-14 0-14zm0 20c0-0 5-0 5-0c0 0 0 14 0 14c7.21.16 13.48 1.67 20 4.78c41.08 19.62 40.4 81.57-2 99.2c-5.73 2.38-11.79 3.94-18 4.02c0 0-8 0-8 0c-18.03-.22-35.65-12.38-44.1-28c-5.31-9.81-6.02-19.17-5.9-30c.34-28.34 25.5-49.98 53-50c0 0 0-14 0-14zm49 60c-7.31-.02-15-1.06-22-3.2c-4.5-1.38-9.27-4.29-14-3.4c-10.53 1.99-16.75 12.9-21.04 15.15c-3.7 1.94-8.73 1.27-12.96 1.88c-10.39 1.49-14.95 3.56-26 3.57c0 0 0 2 0 2c11.76-.01 16.21-2.39 27-3.71c4.63-.57 9.66.31 13.96-1.86c5.15-2.6 8.82-12.38 19.04-14.75c3.95-.92 9.05 1.76 13 2.89c7.51 2.15 15.19 3.41 23 3.43c0 0 0-2 0-2zm1 6c-3.31.15-8.07.41-10.73 2.58c-3.1 2.55-3.02 7.11-6.4 6.89c-1.89-.13-6.02-3.42-7.87-4.54c-5.61-3.39-10.49-4.99-17-3.14c-7.22 2.05-12.52 7.26-19 10.72c-10.1 5.39-22.77 7.5-34 5.49c4.65 4.59 10.07 2.96 16 2.13c8.09-1.13 13.83-2.34 21-6.58c6.85-4.05 14.55-11.25 23-10.35c8.32.89 14.06 9.2 18.95 9.09c4.35-.09 4.22-5.33 6.61-7.78c2.44-2.5 6.21-2.44 9.44-2.51c0 0 0-2 0-2zm-9 29c-8.76-5.92-17.6-17.91-28-18.61c-9.17-.62-18.45 8.91-26 13.1c-9.88 5.47-16.35 4.92-27 3.51c2.78 3.58 6.76 3.08 11 2.99c8.95-.21 15.81-3.34 23-8.41c5.55-3.92 12.74-10.18 20-8.86c7.55 1.37 11.21 6.03 16.28 10.99c3 2.93 6.34 6.32 10.72 5.29zm-5 7c-2.69-3.08-4.46-4.15-8-6.14c-4.22-2.36-8.08-4.56-13-4.82c-9.4-.49-20.78 6.01-30 8.93c-10.05 3.18-13 1.05-18 3.03c16.02 4.55 33.41-8.82 44-10.01c9.92-1.12 16.14 6.84 25 9.01zm-8 5.22c-4.5-.22-10.72-.45-15-0c-5.03 1.01-11.23 3.1-16 3.07c-6.77-.05-15.92-3.7-22-1.29c4.16 1.22 18.89 3.64 23 3.39c0 0 16-2.96 16-2.96c5.09-.73 9.83.64 14-2.21z"
            data-name="Forma 87"
        />
    </svg>
</template>

<script>
    import BrasilidadeMapNortheast from './BrasilidadeMapNortheast';
    import BrasilidadeMapNorth from './BrasilidadeMapNorth';
    import BrasilidadeMapSoutheast from './BrasilidadeMapSoutheast';
    import BrasilidadeMapMidwest from './BrasilidadeMapMidwest';
    import BrasilidadeMapSouth from './BrasilidadeMapSouth';

    export default {
        name: 'BrasilidadeMap',

        props: {
            selectedRegionName: String,
        },

        components: {
            BrasilidadeMapSouth,
            BrasilidadeMapMidwest,
            BrasilidadeMapSoutheast,
            BrasilidadeMapNorth,
            BrasilidadeMapNortheast,
        },

        data() {
            return {
                componentsMap: {
                    'Centro-Oeste': BrasilidadeMapMidwest,
                    Norte: BrasilidadeMapNorth,
                    Nordeste: BrasilidadeMapNortheast,
                    Sudeste: BrasilidadeMapSoutheast,
                    Sul: BrasilidadeMapSouth,
                },
            };
        },
    };
</script>
